import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RoutesRecognized } from '@angular/router';

@Component({
  selector: 'component-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss','../../../styles.scss'],
})
export class NavbarComponent implements OnInit {
  isBrowser = false;
  constructor(private route: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  public showMainNavBar: boolean = true;
  public navbarToShow: string = '';
  ngOnInit(): void {
    this.checkRouteData();
  }
  private checkRouteData() {
    this.router.events.subscribe((event) => {
      // if (event instanceof RoutesRecognized) {
      //   let dataHintValue: boolean = event.state.root.firstChild?.data['showMainNavBar']
      //     ?? event.state.root.firstChild?.firstChild?.data['showMainNavBar'];
      //   if (dataHintValue === undefined) {
      //     this.showMainNavBar = true;
      //   } else dataHintValue ? null : this.showMainNavBar = false;
      // }
      if (event instanceof RoutesRecognized) {
        let dataHintValue: any = event.state.root.firstChild?.data
          ?? event.state.root.firstChild?.firstChild?.data;
        if (!dataHintValue?.showMainNavBar&&dataHintValue?.showMainNavBar!=undefined) { this.navbarToShow = "funnel" }
        else if (dataHintValue?.showMinimalBar) { this.navbarToShow = "minimal" }
      }
    });
  }

}
